import { j as l } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as t } from "react";
import { I as o } from "../../../../IconBase-CxZyIWw2.js";
const s = t((e, i) => /* @__PURE__ */ l.jsx(
  o,
  {
    ref: i,
    ...e,
    image: (r) => /* @__PURE__ */ l.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...r,
        children: [
          /* @__PURE__ */ l.jsx("g", { clipPath: "url(#clip0_3410_69145)", children: /* @__PURE__ */ l.jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M3 0a1 1 0 0 0-1 1v9h2V7h1.628l2.86 4.192L5 15.987h2.473l2.211-3.04 2.074 3.04h2.42l-3.245-4.758L14.01 7h-2.473l-1.8 2.474-1.875-2.749A3.501 3.501 0 0 0 6.5 0zm3.5 5H4V2h2.5a1.5 1.5 0 1 1 0 3",
              clipRule: "evenodd"
            }
          ) }),
          /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "clip0_3410_69145", children: /* @__PURE__ */ l.jsx("path", { fill: "#fff", d: "M0 0h16v16H0z" }) }) })
        ]
      }
    )
  }
));
s.displayName = "TreatmentIcon";
export {
  s as TreatmentIcon,
  s as default
};
//# sourceMappingURL=index.js.map
